@if (canChangeLanguage) {
  <mat-menu #languageMenu="matMenu" xPosition="after" yPosition="above">
    @for (language of availableLanguages; track language) {
      <button mat-menu-item (click)="selectLanguage(language.code)">
        <mat-icon [svgIcon]="language.icon"></mat-icon>
        <span>{{language.nativeLabel}}</span>
      </button>
    }
  </mat-menu>
  <button mat-menu-item [matMenuTriggerFor]="languageMenu">
    @if (selectedLanguage) {
      <mat-icon [svgIcon]="selectedLanguage.icon"></mat-icon>
    }
    <span>{{selectedLanguage?.nativeLabel}}</span>
  </button>
}
